import { FC, useMemo, ReactNode, useCallback } from 'react';
import { useField, useForm } from 'react-final-form';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { useConfirmationDialog } from 'src/components/ConfirmationDialog/useConfirmationDialog';
import { MapInfo } from 'src/store/spaces/types';

import { SpaceBookingObjectOption } from '../types';

import { SpaceGroup } from './SpaceGroup/SpaceGroup';
import classes from './SpaceGroups.module.scss';

export const SpaceGroups: FC = () => {
  const { change } = useForm();
  const groups =
    useField<Map<number, SpaceBookingObjectOption[]>>('groups').input.value;
  const groupInfos = useField<Map<number, MapInfo>>('groupInfos').input.value;

  const {
    dialog: deleteGroupDialog,
    open: openDeleteGroupDialog,
    confirmation: confirmDeleteGroup,
  } = useConfirmationDialog({
    title: 'Удалить группу?',
    okLabel: 'Удалить',
    cancelLabel: 'Назад',
    text: 'Если ты удалишь группу, все добавленные места исчезнут. Вернуть их нельзя — придётся добавлять всё заново.',
  });

  const deleteGroup = useCallback(
    async (groupId: number) => {
      openDeleteGroupDialog();
      const confirmed = await confirmDeleteGroup();
      if (!confirmed) return;

      const nextGroups = new Map(groups);
      const nextGroupInfos = new Map(groupInfos);

      nextGroups.delete(groupId);
      nextGroupInfos.delete(groupId);

      change('groups', nextGroups);
      change('groupInfos', nextGroupInfos);
    },
    [change, confirmDeleteGroup, groupInfos, groups, openDeleteGroupDialog],
  );

  const nodes = useMemo(() => {
    const result: ReactNode[] = [];
    for (const [floorId, group] of groups) {
      const info = groupInfos.get(floorId);
      if (info)
        result.push(
          <SpaceGroup
            key={floorId}
            options={group}
            groupInfo={info}
            onDelete={deleteGroup}
          />,
        );
    }
    return result;
  }, [deleteGroup, groupInfos, groups]);

  return (
    <>
      {deleteGroupDialog}

      <div className={classes.container}>
        {groups.size ? (
          <div className={classes.desks}>{nodes}</div>
        ) : (
          <div className={classes.empty}>
            <Typography>Места не добавлены</Typography>
          </div>
        )}
      </div>
    </>
  );
};
